import localhost from "apis/localhost";

import {
  setAgencies,
  setAgenciesLoaded,
  setAgenciesLoading,
} from "./agenciesSlice";

export const fetchAgencies = () => async (dispatch, getState) => {
  const { agenciesLoaded, agenciesLoading } = getState().opportunity.agencies;

  // Prevent duplicate fetches
  if (agenciesLoaded || agenciesLoading) {
    return;
  }

  dispatch(setAgenciesLoading(true));
  try {
    const rsp = await localhost.get("/nextgen/customers/with-agencies");
    const data = rsp?.data || [];
    dispatch(setAgencies(data));
    dispatch(setAgenciesLoaded(true));
  } catch (err) {
    console.error("Failed to fetch agencies:", err);
    dispatch(setAgencies([]));
  } finally {
    dispatch(setAgenciesLoading(false));
  }
};
